import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { PromiseDepartment } from "@enums/promiseDepartment.enum";
import { PromiseType } from "@enums/promiseType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Promise } from "@interfaces/promise.interface";
import { PromiseService } from "@services/promise.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "promises-board",
	styleUrls: ["promises-board.css"],
	templateUrl: "promises-board.html"
})
export class PromisesBoardAdminComponent {
	deleteEnabled = true;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	popupAddButtonOptions: any;
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupPromise: Promise = new Promise();
	popupTitle = "";
	popupVisible = false;
	promiseBoard: any[] = [];
	promiseDepartments: any;
	promiseTypes: any;
	title = "Promise Board";
	
	constructor(private router: Router, private toastService: ToastService, private promiseService: PromiseService) {
		this.promiseDepartments = GetPropertiesFromEnum(PromiseDepartment);
		this.promiseTypes = GetPropertiesFromEnum(PromiseType);
		this.headerPrimaryButtons.push({ icon: "fal fa-th-large", method: "viewGrid", text: "Grid" });
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewPromisePopup", text: "New Promise" });
		this.getBoard();
	}

	addNewPromise() {		
		this.promiseService.createSingle(this.popupPromise)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.popupPromise = new Promise();
					this.getBoard();
					this.toastService.success("Promise Created");
				},
				(err: any) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);

		this.closePopup();
	}

	addNewPromisePopup() {
		this.popupPromise = new Promise();
		this.popupTitle = "Add New Promise";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewPromise(), text: "Add Promise" };
	}

	closePopup() {
		this.popupVisible = false;
		this.popupPromise = new Promise();
	}

	editPromise() {		
		this.promiseService.updateSingleById(this.popupPromise.id, this.popupPromise)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.popupPromise = new Promise();
					this.getBoard();
					this.toastService.success("Promise Updated");
				},
				(err: any) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);

		this.closePopup();
	}

	editPromisePopup(e: any) {
		this.popupPromise = new Promise(e);
		this.popupTitle = "Edit Promise";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.editPromise(), text: "Save Changes" };
		return false;
	}

	getBoard() {
		this.promiseService.getPromiseBoard()
			.subscribe(
				(res: any) => this.promiseBoard = res.response,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	viewGrid() {
		this.router.navigate(["admin/promises"]);
	}
}